import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetNotification, Logoutuser, Property } from "../../Services/Service";
import { useProperty } from "../../PropertyContext";

const ReservationHeader = () => {
  const navigate = useNavigate();
  const { selectedProperty, setSelectedProperty } = useProperty();
  const [location, setLocation] = useState([])
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const FetchLocation = async () => {
      try {
        const result = await Property();
        // console.log("results",result)
        const data = Array.isArray(result) ? result : [];
        setLocation(data);

        if (data.length > 0 && !selectedProperty) {
          setSelectedProperty(data[0]);
        }
      }
      catch (error) {
        console.log("error Fetching Locations", error);
      } finally {
        setLoading(false);
      }
    }
    FetchLocation();
  }, [selectedProperty, setSelectedProperty]);

  // Fetch notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const result = await GetNotification();
        setNotifications(Array.isArray(result) ? result : []);
      }
      catch (error) {
        console.log("getting notify error", error);
      }
    };
    fetchNotifications();
  }, []);


  const handleLogout = async () => {
    setLoading(true);
    try {
      const result = await Logoutuser();

      if (result && result.includes("logged out")) {
        localStorage.clear();
        navigate("/");
      } else {
        console.log("Logout failed:", result);
      }
    }
    catch (error) {
      console.log("Logout error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}
      <div className="main-header">
        <div className="main-header-logo">
          {/* Logo Header */}
          <div className="logo-header" data-background-color="dark">
            <div className="nav-toggle">
              <button className="btn btn-toggle toggle-sidebar">
                <i className="gg-menu-right" />
              </button>
              <button className="btn btn-toggle sidenav-toggler">
                <i className="gg-menu-left" />
              </button>
            </div>
            <button className="topbar-toggler more">
              <i className="gg-more-vertical-alt" />
            </button>
          </div>
          {/* End Logo Header */}
        </div>
        {/* Navbar Header */}
        <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom" >
          <div className="container-fluid">

            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center" >
              <div className="btn-group dropdown">
                <button className="btn btn-outline-dark btn-sm mx-3" type="button" data-bs-toggle="dropdown">{selectedProperty ? selectedProperty.PropertyName : "Change Location"}<i className="fas fa-angle-down ms-2"></i></button>
                <ul className="dropdown-menu" role="menu">
                  {loading ? (
                    <li className="dropdown-item">Loading...</li>
                  ) : location.length > 0 ? (
                    location.map((loc, index) => (
                      <li key={index} className="nav-item">
                        {/* <button className="dropdown-item" onClick={() => setSelectedProperty(loc)} >{loc.PropertyName}</button> */}
                        <button className={`dropdown-item ${selectedProperty?.PropertyID === loc.PropertyID ? "active" : ""}`} onClick={() => setSelectedProperty(loc)} >
                          {loc.PropertyName}
                        </button>
                      </li>
                    ))
                  ) : (
                    <li className="dropdown-item">No Locations Found</li>
                  )}
                </ul>
              </div>

              <li className="nav-item topbar-icon dropdown hidden-caret">
                <a
                  className="nav-link dropdown-toggle"
                  href="/"
                  id="notifDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-bell"></i>
                  {notifications.length > 0 && (
                    <span className="notification">{notifications.length}</span>
                  )}
                </a>
                <ul
                  className="dropdown-menu notif-box animated fadeIn"
                  aria-labelledby="notifDropdown"
                  style={{ overflowY: "scroll" }}
                >
                  <li>
                    <div className="dropdown-title">
                      You have {notifications.length} new notification
                      {notifications.length > 1 ? "s" : ""}
                    </div>
                  </li>
                  <li>
                    <div className="notif-scroll scrollbar-outer">
                      <div className="notif-center">
                        {notifications.length > 0 ? (
                          notifications.map((notif) => (
                            <a href="/" key={notif.ID}>
                              <div className={`notif-icon notif-${notif.Type}`}>
                                <i className="fa fa-info-circle"></i>
                              </div>
                              <div className="notif-content">
                                <span className="block fw-bold">{notif.Title}</span>
                                <small>{notif.Message}</small><br />
                                <span className="time">{notif.CreatedAt}</span>
                              </div>
                            </a>
                          ))
                        ) : (
                          <div className="text-center p-2">No new notifications</div>
                        )}

                      </div>
                    </div>
                  </li>
                  {/* <li>
                      <a className="see-all" href="/"
                        >See all notifications<i className="fa fa-angle-right"></i>
                      </a>
                    </li> */}
                </ul>
              </li>
              <li className="nav-item topbar-user dropdown hidden-caret">
                <a
                  className="dropdown-toggle profile-pic"
                  data-bs-toggle="dropdown"
                  href="/"
                  aria-expanded="false"
                >
                  <i className="fas fa-list-ul"></i>
                </a>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">

                    <li>

                      <button className="dropdown-item">
                        <i className="fas fa-calendar-check me-2"></i>
                        Bookings
                      </button>

                      <button className="dropdown-item">
                        <i className="fas fa-trash me-2"></i>
                        Delete Account
                      </button>

                      <div className="dropdown-divider" />
                      <button className="dropdown-item" onClick={handleLogout} >
                        <i className="fas fa-sign-out-alt me-2"></i>
                        Logout
                      </button>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* End Navbar */}
      </div>

    </>
  )
}

export default ReservationHeader;
